var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"LcX5vqQS8z77pSoSl1XEW"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the intialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN =
  process.env.SENTRY_PUBLIC_DSN || process.env.NEXT_PUBLIC_SENTRY_PUBLIC_DSN;

Sentry.init({
  dsn:
    SENTRY_DSN ||
    'https://04b39aec2353486c9652b7181e7f0e3b@o62215.ingest.sentry.io/133522',
  environment: process.env.SENTRY_ENV || 'development',
  enabled: process.env.SENTRY_ENABLED || false,
  tracesSampleRate: 1,
  debug: false,
  // beforeSend(event) {
  //   const header =
  //     event?.request?.headers['User-Agent']?.includes('MSIE') || false;
  //   // Do not log developement and IE issues
  //   // user agent for IE is MSIE
  //   if (event.release === 'development' || header) {
  //     return null;
  //   }
  // },
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
});
